var map = {
	"./My-Vote.png": "1916",
	"./about-bg.png": "dae8",
	"./about.jpg": "a46c",
	"./anything.png": "d437",
	"./avatar.png": "1195",
	"./booth.jpg": "21ce",
	"./depositeback.png": "6f55",
	"./faq.jpg": "f71d",
	"./fonts/bootstrap-icons.woff": "1520",
	"./fonts/bootstrap-icons.woff2": "b58f",
	"./goverment.png": "1eef",
	"./hero-bg.png": "9bda",
	"./logo (copy).png": "d275",
	"./logo-m.png": "a8b2",
	"./logo.png": "cf05",
	"./logo.svg": "9b19",
	"./myvoco_votes_about_us_logo.jpg": "ed4b",
	"./nurses.png": "cb8f",
	"./onevone.png": "9ebd",
	"./people_voting.jpg": "f12d",
	"./pirate.png": "d1ac",
	"./private.png": "27af",
	"./sample-logo.png": "a2b8",
	"./sports.png": "ef6f",
	"./st-banner.png": "5583",
	"./template1.png": "cb86",
	"./template2.png": "5d7c",
	"./united.png": "fe07",
	"./unknown.png": "c02d",
	"./upload.png": "cf55",
	"./variables.css": "1d22",
	"./vote.png": "5d9c",
	"./voter-template-2.png": "56e3",
	"./voting-template-1.png": "1564",
	"./women.png": "1d57",
	"./world_voting.jpg": "1a3a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";